






























import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { PublicationModel } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "ArticleFolder",
		components: { ButtonList }
	})
export default class ArticleFolder extends ParticaBaseForm<PublicationModel> {

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "name", disabled: false } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;

	private guidconfig =
		{
			props: { name: "guid", placeholder: "Enter guid", label: "guid", disabled: true, } as FormFieldProps,
			rules: { required: false, } as FormFieldRules
		} as IFormField;

	private languageconfig =
		{
			props: {
				name: "language", placeholder: "Choose language", label: "language", required: true, disabled: true,
				values: [
					{ label: "English", value: "english" } as EnumDTO,
					{ label: "German", value: "german" } as EnumDTO,
					{ label: "Swedish", value: "swedish" } as EnumDTO,
					{ label: "Spanish", value: "spanish" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: false, numeric: true } as FormFieldRules
		} as IFormField;
}
